import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { profilesAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function ProfilePage() {
  const { uuid } = useParams();
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    profilesAPI.getProfile(uuid)
      .then(res => setProfile(res.data.profile || {}))
      .catch(() => toast.error('فشل تحميل الملف الشخصي'))
      .finally(() => setLoading(false));
  }, [uuid]);

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!profile?.id) return <div className="page-wrapper" style={{textAlign:'center',paddingTop:80}}><h2>الملف الشخصي غير موجود</h2><Link to="/professionals" className="btn btn-primary" style={{marginTop:16}}>العودة للمحترفين</Link></div>;

  const isOwn = user?.uuid === uuid;
  const skills = Array.isArray(profile.skills) ? profile.skills : [];
  const languages = Array.isArray(profile.languages) ? profile.languages : [];
  const AVAIL = { full_time:'دوام كامل', part_time:'دوام جزئي', freelance:'عمل حر', contract:'عقد' };

  return (
    <div className="page-wrapper" style={{paddingBottom:48}}>
      {/* Cover */}
      <div style={{height:200,background:'linear-gradient(135deg,#0D1421 0%,#0a2a4a 50%,#0D1421 100%)',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,backgroundImage:'radial-gradient(ellipse at 30% 50%, rgba(0,212,255,0.15) 0%, transparent 60%), radial-gradient(ellipse at 70% 50%, rgba(255,107,53,0.1) 0%, transparent 60%)'}} />
      </div>

      <div className="container" style={{maxWidth:960}}>
        {/* Header */}
        <div className="card" style={{padding:28,marginTop:-60,marginBottom:24,position:'relative'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:16}}>
            <div style={{display:'flex',gap:20,alignItems:'flex-start'}}>
              <div style={{width:100,height:100,borderRadius:'50%',background:'linear-gradient(135deg,var(--color-primary),#FF6B35)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:36,fontWeight:800,color:'#000',border:'4px solid var(--color-bg-card)',marginTop:-40,flexShrink:0}}>
                {profile.full_name?.[0]}
              </div>
              <div style={{paddingTop:4}}>
                <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                  <h1 style={{fontSize:24,fontWeight:800,margin:0}}>{profile.full_name}</h1>
                  {profile.is_verified===1 && <span style={{background:'rgba(0,212,255,0.15)',color:'var(--color-primary)',padding:'2px 10px',borderRadius:20,fontSize:12,fontWeight:600}}>✓ موثّق</span>}
                </div>
                <div style={{color:'var(--color-primary)',fontWeight:600,fontSize:15,margin:'4px 0'}}>{profile.job_title || 'محترف رياضي'}</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:12,fontSize:13,color:'var(--color-text-muted)',marginTop:6}}>
                  {profile.sport_category && <span>🏆 {profile.sport_category}</span>}
                  {profile.city && <span>📍 {profile.city}{profile.country && `, ${profile.country}`}</span>}
                  {profile.years_experience > 0 && <span>⏳ {profile.years_experience} سنوات خبرة</span>}
                  {profile.availability && <span>💼 {AVAIL[profile.availability] || profile.availability}</span>}
                </div>
              </div>
            </div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
              {isOwn ? (
                <Link to="/profile/edit" className="btn btn-primary" style={{padding:'10px 20px'}}>✏️ تعديل الملف</Link>
              ) : (
                <>
                  <Link to="/messages" className="btn btn-primary" style={{padding:'10px 20px'}}>💬 تواصل</Link>
                  <button className="btn btn-ghost" style={{padding:'10px 20px'}}>⭐ حفظ</button>
                </>
              )}
            </div>
          </div>

          {/* Stats */}
          <div style={{display:'flex',gap:24,marginTop:20,paddingTop:20,borderTop:'1px solid rgba(255,255,255,0.08)',flexWrap:'wrap'}}>
            <div style={{textAlign:'center'}}><div style={{fontSize:20,fontWeight:700,color:'var(--color-primary)'}}>{profile.years_experience || 0}</div><div style={{fontSize:12,color:'var(--color-text-muted)'}}>سنوات خبرة</div></div>
            <div style={{textAlign:'center'}}><div style={{fontSize:20,fontWeight:700,color:'var(--color-primary)'}}>{skills.length}</div><div style={{fontSize:12,color:'var(--color-text-muted)'}}>مهارة</div></div>
            <div style={{textAlign:'center'}}><div style={{fontSize:20,fontWeight:700,color:'var(--color-primary)'}}>{languages.length}</div><div style={{fontSize:12,color:'var(--color-text-muted)'}}>لغة</div></div>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 300px',gap:20,alignItems:'start'}}>
          {/* Main */}
          <div>
            {/* Bio */}
            {profile.bio && (
              <div className="card" style={{padding:24,marginBottom:16}}>
                <h3 style={{fontSize:16,fontWeight:700,marginBottom:12,display:'flex',alignItems:'center',gap:8}}>👤 نبذة شخصية</h3>
                <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:14}}>{profile.bio}</p>
              </div>
            )}

            {/* Experience */}
            {profile.experience?.length > 0 && (
              <div className="card" style={{padding:24,marginBottom:16}}>
                <h3 style={{fontSize:16,fontWeight:700,marginBottom:16,display:'flex',alignItems:'center',gap:8}}>💼 الخبرات المهنية</h3>
                <div style={{display:'flex',flexDirection:'column',gap:16}}>
                  {profile.experience.map((exp, i) => (
                    <div key={i} style={{display:'flex',gap:14,paddingBottom:16,borderBottom:i<profile.experience.length-1?'1px solid rgba(255,255,255,0.06)':'none'}}>
                      <div style={{width:42,height:42,borderRadius:10,background:'rgba(0,212,255,0.1)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>🏢</div>
                      <div>
                        <div style={{fontWeight:700,fontSize:15}}>{exp.title || exp.position}</div>
                        <div style={{color:'var(--color-primary)',fontSize:13,margin:'2px 0'}}>{exp.organization}</div>
                        <div style={{color:'var(--color-text-muted)',fontSize:12}}>{exp.start_date?.substring(0,7)} — {exp.is_current?'حتى الآن':exp.end_date?.substring(0,7)}</div>
                        {exp.description && <p style={{color:'var(--color-text-muted)',fontSize:13,marginTop:6,lineHeight:1.7}}>{exp.description}</p>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Education */}
            {profile.education?.length > 0 && (
              <div className="card" style={{padding:24,marginBottom:16}}>
                <h3 style={{fontSize:16,fontWeight:700,marginBottom:16,display:'flex',alignItems:'center',gap:8}}>🎓 التعليم</h3>
                <div style={{display:'flex',flexDirection:'column',gap:16}}>
                  {profile.education.map((edu, i) => (
                    <div key={i} style={{display:'flex',gap:14}}>
                      <div style={{width:42,height:42,borderRadius:10,background:'rgba(255,107,53,0.1)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>🎓</div>
                      <div>
                        <div style={{fontWeight:700,fontSize:15}}>{edu.degree} — {edu.field}</div>
                        <div style={{color:'var(--color-primary)',fontSize:13,margin:'2px 0'}}>{edu.institution}</div>
                        <div style={{color:'var(--color-text-muted)',fontSize:12}}>{edu.start_year} — {edu.end_year||'حتى الآن'}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Services */}
            {profile.services?.length > 0 && (
              <div className="card" style={{padding:24,marginBottom:16}}>
                <h3 style={{fontSize:16,fontWeight:700,marginBottom:16}}>⚡ الخدمات المقدمة</h3>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  {profile.services.map(s => (
                    <Link to={`/services/${s.uuid||s.id}`} key={s.id} style={{textDecoration:'none',padding:16,background:'rgba(0,212,255,0.05)',border:'1px solid rgba(0,212,255,0.15)',borderRadius:12,display:'block',transition:'all 0.2s'}}>
                      <div style={{fontWeight:600,fontSize:14,marginBottom:4}}>{s.title}</div>
                      <div style={{color:'var(--color-primary)',fontSize:13,fontWeight:700}}>{s.price} {s.price_currency}</div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Sidebar */}
          <div>
            {/* Skills */}
            {skills.length > 0 && (
              <div className="card" style={{padding:20,marginBottom:16}}>
                <h4 style={{fontSize:14,fontWeight:700,marginBottom:12}}>🎯 المهارات</h4>
                <div style={{display:'flex',flexWrap:'wrap',gap:8}}>
                  {skills.map((s,i) => <span key={i} style={{background:'rgba(0,212,255,0.1)',border:'1px solid rgba(0,212,255,0.25)',color:'var(--color-primary)',padding:'5px 12px',borderRadius:20,fontSize:12}}>{s}</span>)}
                </div>
              </div>
            )}

            {/* Languages */}
            {languages.length > 0 && (
              <div className="card" style={{padding:20,marginBottom:16}}>
                <h4 style={{fontSize:14,fontWeight:700,marginBottom:12}}>🌐 اللغات</h4>
                <div style={{display:'flex',flexDirection:'column',gap:8}}>
                  {languages.map((l,i) => <div key={i} style={{display:'flex',alignItems:'center',gap:8,fontSize:13}}><span style={{color:'var(--color-primary)'}}>◆</span>{l}</div>)}
                </div>
              </div>
            )}

            {/* Info */}
            <div className="card" style={{padding:20,marginBottom:16}}>
              <h4 style={{fontSize:14,fontWeight:700,marginBottom:12}}>📋 معلومات</h4>
              <div style={{display:'flex',flexDirection:'column',gap:10,fontSize:13}}>
                {profile.nationality && <div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'var(--color-text-muted)'}}>الجنسية</span><span style={{fontWeight:600}}>{profile.nationality}</span></div>}
                {profile.expected_salary && <div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'var(--color-text-muted)'}}>الراتب المتوقع</span><span style={{fontWeight:600,color:'var(--color-primary)'}}>{profile.expected_salary}</span></div>}
                {profile.availability && <div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'var(--color-text-muted)'}}>التوفر</span><span style={{fontWeight:600}}>{AVAIL[profile.availability]}</span></div>}
                {profile.is_available===1 && <div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'var(--color-text-muted)'}}>الحالة</span><span style={{color:'#00C851',fontWeight:600}}>● متاح للعمل</span></div>}
              </div>
            </div>

            {/* Contact */}
            {(profile.linkedin_url || profile.portfolio_url) && (
              <div className="card" style={{padding:20}}>
                <h4 style={{fontSize:14,fontWeight:700,marginBottom:12}}>🔗 روابط</h4>
                <div style={{display:'flex',flexDirection:'column',gap:8}}>
                  {profile.linkedin_url && <a href={profile.linkedin_url} target="_blank" rel="noreferrer" style={{color:'var(--color-primary)',fontSize:13,textDecoration:'none'}}>LinkedIn ↗</a>}
                  {profile.portfolio_url && <a href={profile.portfolio_url} target="_blank" rel="noreferrer" style={{color:'var(--color-primary)',fontSize:13,textDecoration:'none'}}>Portfolio ↗</a>}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
